import { render, staticRenderFns } from "./api-detail-dailog.vue?vue&type=template&id=59d6f01f&scoped=true&"
import script from "./api-detail-dailog.vue?vue&type=script&lang=js&"
export * from "./api-detail-dailog.vue?vue&type=script&lang=js&"
import style0 from "./api-detail-dailog.vue?vue&type=style&index=0&id=59d6f01f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d6f01f",
  null
  
)

export default component.exports